import { render } from "./AdminFrontPage.vue?vue&type=template&id=474a2d72"
import script from "./AdminFrontPage.vue?vue&type=script&lang=js"
export * from "./AdminFrontPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__